module.exports = __webpack_public_path__ + "img/1stopshop.23941539.svg";